(() => {
  if (window.wlyBuyFormReady) return;
  window.wlyBuyFormReady = true;
  document.addEventListener('change', (event) => {
    const wlyRadio = event.target.closest('[data-wly-buy-form] input[type="radio"][name="id"]');
    if (!wlyRadio) return;
    const wlyForm = wlyRadio.closest('[data-wly-buy-form]');
    const wlyPrice = wlyForm.querySelector('[data-wly-price]');
    const wlyButton = wlyForm.querySelector('[data-wly-add-button]');
    if (wlyPrice) wlyPrice.textContent = wlyRadio.dataset.wlyPriceText;
    if (wlyButton) wlyButton.textContent = wlyRadio.dataset.wlyAddText;
  });
  document.addEventListener('submit', async (event) => {
    const wlyForm = event.target.closest('[data-wly-buy-form]');
    if (!wlyForm) return;
    event.preventDefault();
    const wlyButton = wlyForm.querySelector('[data-wly-add-button]');
    const wlyError = wlyForm.querySelector('[data-wly-error]');
    wlyButton.disabled = true;
    wlyButton.setAttribute('aria-busy', 'true');
    if (wlyError) wlyError.hidden = true;
    try {
      const wlyResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(wlyForm),
        wlyOwn: true,
      });
      const wlyData = await wlyResponse.json();
      if (!wlyResponse.ok) throw new Error(wlyData.description || wlyData.message);
      document.dispatchEvent(new CustomEvent('theme:cart::added', { detail: { data: wlyData } }));
      if (window.wlyCart) {
        await window.wlyCart.refresh({ open: true });
      } else if (window.theme?.Cart?.updateCart) {
        await window.theme.Cart.updateCart();
        window.theme.Cart.showPopup?.();
      } else {
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      }
    } catch (wlyErr) {
      if (wlyError) {
        wlyError.textContent = wlyErr.message;
        wlyError.hidden = false;
      }
    } finally {
      wlyButton.disabled = false;
      wlyButton.removeAttribute('aria-busy');
    }
  });
})();
